import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { money, monthLabel } from "../lib/format";

const tip = { cursor: { fill: "#1E293B" }, labelStyle: { color: "#F1F5F9" }, itemStyle: { color: "#E2E8F0" },
  contentStyle: { background: "#0B0F17", border: "1px solid #334155", borderRadius: 6 } };
const axis = { stroke: "#64748B", fontSize: 11, tickLine: false, axisLine: false };
const box = "rounded border border-slate-800 bg-[#0B0F17] p-3";
const head = "text-[11px] font-mono uppercase text-slate-500 mb-2";

export function AttritionTrend({ months, testId = "attrition-trend-chart" }) {
  const data = months.map((m) => ({ label: monthLabel(m.month), Lost: m.lost, New: m.new }));
  return (
    <div className={box}>
      <div className={head}>Lost merchants vs new accounts</div>
      <div className="h-[220px]" data-testid={testId}>
        <ResponsiveContainer>
          <BarChart data={data} margin={{ left: -10, right: 10, top: 10 }} maxBarSize={48}>
            <CartesianGrid stroke="#1E293B" vertical={false} />
            <XAxis dataKey="label" {...axis} />
            <YAxis allowDecimals={false} {...axis} />
            <Tooltip {...tip} />
            <Legend wrapperStyle={{ fontSize: 11, color: "#94A3B8" }} />
            <Bar dataKey="New" fill="#10B981" radius={[3, 3, 0, 0]} />
            <Bar dataKey="Lost" fill="#F43F5E" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function AgentBars({ rows }) {
  return (
    <div className="h-[240px]" data-testid="attrition-agent-chart">
      <ResponsiveContainer>
        <BarChart data={rows} margin={{ left: -10, right: 10, top: 10 }} maxBarSize={48}>
          <CartesianGrid stroke="#1E293B" vertical={false} />
          <XAxis dataKey="owner" {...axis} interval={0} />
          <YAxis allowDecimals={false} {...axis} />
          <Tooltip {...tip} formatter={(v, n, p) => (n === "Lost" ? [`${v} · ${money(p.payload.lost_residual)} residual`, n] : v)} />
          <Bar dataKey="lost" name="Lost" fill="#F43F5E" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function AttritionByAgent({ rows, range }) {
  if (!rows.length) return null;
  return (
    <div className={box} data-testid="attrition-by-agent">
      <div className={head}>Attrition by agent · {range}</div>
      <AgentBars rows={rows} />
      <table className="tbl w-full mt-3" data-testid="attrition-agent-table">
        <thead><tr><th>Agent</th><th className="!text-right">Merchants at start</th><th className="!text-right">Lost</th>
          <th className="!text-right">Rate</th><th className="!text-right">Residual lost</th><th className="!text-right">SaaS fees lost</th></tr></thead>
        <tbody>{rows.map((a) => (
          <tr key={a.owner} data-testid={`attrition-agent-row-${a.owner.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <td className="text-slate-200">{a.owner}</td><td className="text-right font-mono">{a.start}</td>
            <td className="text-right font-mono text-rose-400">{a.lost}</td><td className="text-right font-mono">{a.rate}%</td>
            <td className="text-right font-mono">{money(a.lost_residual)}</td><td className="text-right font-mono text-amber-300">{money(a.lost_fee)}</td>
          </tr>))}</tbody>
      </table>
    </div>
  );
}
